import moment from 'moment'



export function callbackUrl(url, success, msg, vcount, vprice) {
  const i = url.indexOf('&')
  if(i>=0) {
    const backUrl = url + '&success=' + success + '&msg=' + msg + (success ? '&vcount=' + vcount + '&vprice=' + vprice : '')
    return backUrl
  } else {
    const backUrl = url + '?success=' + success + '&msg=' + msg + (success ? '&vcount=' + vcount + '&vprice=' + vprice : '')
    return backUrl
  }
}

// 判断是否为数字，包含小数点
export function isNumber( s )
{
    var regu = '^([0-9])[0-9]*(\\.\\w*)?$'
//    var regu = "^[0-9]*$";
    var re = new RegExp(regu)
    if (re.test(s))
    {
        return true
    }
    else
    {
        return false
    }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result

    const later = function() {
    // 据上一次触发时间间隔
        const last = +new Date() - timestamp

        // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last)
        } else {
            timeout = null
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if (!immediate) {
                result = func.apply(context, args)
                if (!timeout) context = args = null
            }
        }
    }

    return function(...args) {
        context = this
        timestamp = +new Date()
        const callNow = immediate && !timeout
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait)
        if (callNow) {
            result = func.apply(context, args)
            context = args = null
        }

        return result
    }
}

/**
 * 格式化日期
 */
export function dateFormat(val) {
    const date = new Date(val)
    return moment(date).format('YYYY-MM-DD')
}

/**
 * 判断是否为IOS
 */
export function isIOS() {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        return true
    }
    return false
}

/**
 * 判断是否为android
 */
export function isAndroid() {
    if (/(Android)/i.test(navigator.userAgent)) {
        return true
    }
    return false
}



// WEBPACK FOOTER //
// ./src/utils/index.js